export default __webpack_public_path__ + "static/media/earthling_4.9357d892.png";